type DraftStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const key = (episodeId: string) => `dream.production.recovery.${episodeId}`;
export function rememberRecovery<T>(storage: DraftStorage, episodeId: string, draft: T) {
  storage.setItem(key(episodeId), JSON.stringify(draft));
}
export function readRecovery<T>(storage: DraftStorage, episodeId: string): T | null {
  try {
    return JSON.parse(storage.getItem(key(episodeId)) ?? 'null') as T | null;
  } catch {
    return null;
  }
}
export function forgetRecovery(storage: DraftStorage, episodeId: string) {
  storage.removeItem(key(episodeId));
}
